import { IPendingMessageAttachment } from "./Conversation";
import { Box, Button, Flex, IconButton } from "@radix-ui/themes";
import FontAwesome from "../../utilities/FontAwesome";
import ClickableLink from "../../utilities/ClickableLink";
import styles from "../styles/MessageAttachment.module.scss";

export function AttachmentPreview(props: {
  attachment: IPendingMessageAttachment;
  deleteAttachment: (url: IPendingMessageAttachment["url"]) => void;
}) {
  return (
    <Button variant={"outline"} asChild>
      <ClickableLink
        href={props.attachment.url}
        className={styles.previewContainer}
      >
        <Flex gapX={"2"} align={"center"}>
          <FontAwesome prefix={"far"} name={"fa-file"} />
          <Box className={styles.name}>{props.attachment.name}</Box>
          <IconButton
            variant={"ghost"}
            size={"1"}
            onClick={(e) => {
              e.preventDefault();
              props.deleteAttachment(props.attachment.url);
            }}
          >
            <FontAwesome prefix={"fas"} name={"fa-times"} />
          </IconButton>
        </Flex>
      </ClickableLink>
    </Button>
  );
}
